<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="..."
          @click="handleClickOnCode()"
        ></fg-input>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.description') }}</label>
          <br />
          <el-input
            maxlength="200"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.description"
            class="shadow-sm"
          ></el-input>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {},

  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        description: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      categories: [],
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],

  methods: {
    handleClickOnCode() {
      const tableCodes = Object(
        JSON.parse(sessionStorage.getItem('tableCode'))
      );

      if (
        !isset(this.model.group_code) &&
        !sessionStorage.getItem('editForm')
      ) {
        this.codeGenerator('Categorías', tableCodes, 'code');
      }
    },

    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillCategoriesForm', 'firstStep', this.model);
        return res;
      });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('assistance/category')])
        .then((response) => {
          const response_categories = response;
          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model.id = editForm.id;
            this.model.name = editForm.name;
            this.model.code = editForm.code;
            this.model.description = editForm.description;
          }
          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
